import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { ZiggyVue } from "ziggy";
import { Ziggy } from "./ziggy";

require("./bootstrap");

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin, ZiggyVue, Ziggy)
            .use(VueGoogleMaps, {
                load: { key: "AIzaSyA2oPCNl0YFH4Ms6ZB7ACef2SwqNBaFLgo" },
                autobindAllEvents: true,
            })
            .mount(el);
    },
});

InertiaProgress.init({
    delay: 250,
    color: "#29d",
    includeCSS: true,
    showSpinner: true,
});
